import styled from 'styled-components'

export const GlobalSearchTriggerButtonPlaceholderStyled = styled.span`
  flex: 1;
  text-align: left;
  color: ${(props) => props.theme.colors.globalCommand.text};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
